// Dev-only embed mode guard.
// This module determines whether the BPM embed dev tools are allowed.
// The check is intentionally redundant: both build-time AND runtime conditions must be true.

/**
 * Returns true ONLY when ALL conditions are met:
 * 1. Vite dev mode (import.meta.env.DEV === true) — false in production builds
 * 2. VITE_EMBED_DEV_ENABLED explicitly set to 'true'
 *
 * This function is the single source of truth for embed dev access.
 * Components should never bypass it.
 */
export function isEmbedDevAllowed(): boolean {
  try {
    // import.meta.env.DEV is a Vite built-in: true during `vite dev`, false after `vite build`
    const isDev = import.meta.env.DEV === true;
    const isEnabled = import.meta.env.VITE_EMBED_DEV_ENABLED === 'true';
    return isDev && isEnabled;
  } catch {
    return false;
  }
}
